enum HttpStatus {
  NOT_FOUND = 404,
}

export { HttpStatus }
